import { render, staticRenderFns } from "./MessagePreview.vue?vue&type=template&id=0a2129f9"
import script from "./MessagePreview.vue?vue&type=script&lang=js"
export * from "./MessagePreview.vue?vue&type=script&lang=js"
import style0 from "./MessagePreview.vue?vue&type=style&index=0&id=0a2129f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports